module.exports = __webpack_public_path__ + "img/img01.d01fa83c.png";